import config from './config'

const FORM_CONFIG = `
    ${config}
`

export const FORM_LAYOUT = FORM_CONFIG
